var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLargeFan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 339,
    viewBox: "0 0 121 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "large_fan"
  }, /*#__PURE__*/React.createElement("path", {
    id: "base_shade",
    d: "M72.72 64.0469H69.1603L65.5078 338.111H72.72H79.9323L76.2488 64.0469H72.72Z",
    fill: "#D4F0E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "base",
    d: "M69 64.1113H67.5193L66 338.111H69H72L70.4678 64.1113H69Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fan"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M81.708 60H66.5345C64.5845 60 63 62.1328 63 64.7836C63 67.4344 64.5845 69.5673 66.5345 69.5673H81.708C83.658 69.5673 85.2425 67.4344 85.2425 64.7836C85.2425 62.1328 83.658 60 81.708 60Z",
    fill: "#D4F0E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M65.0399 63.6797C64.3086 63.6797 63.6992 64.5024 63.6992 65.5078C63.6992 66.5133 64.3086 67.336 65.0399 67.336C65.7711 67.336 66.3805 66.5133 66.3805 65.5078C66.3805 64.5024 65.7711 63.6797 65.0399 63.6797Z",
    fill: "#D4F0E6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1686552861"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M65.0392 60.6934C63.0892 60.6934 61.5049 62.8262 61.5049 65.477C61.5049 68.1278 63.0892 70.2606 65.0392 70.2606C66.9892 70.2606 68.5735 68.1278 68.5735 65.477C68.5735 62.8262 66.9892 60.6934 65.0392 60.6934Z",
    fill: "#D4F0E6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fan_center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M64.4699 70.3874C64.5309 72.6421 65.2012 74.8054 66.4504 76.6945L95.1522 120.448C95.7006 121.301 97.0413 120.631 96.6756 119.686L80.1615 74.4703C79.613 72.9469 78.577 71.6366 77.2669 70.7225C77.2669 70.7225 67.8825 63.4406 67.395 63.2578L64.2871 63.7757L64.4699 70.3874V70.3874Z",
    fill: "#D4F0E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M64.4699 70.3874C64.5309 72.6421 65.2012 74.8054 66.4504 76.6945L95.1522 120.448C95.7006 121.301 97.0413 120.631 96.6756 119.686L74.6113 79.8398C74.6113 79.8398 67.8825 63.4406 67.395 63.2578L64.2871 63.7757L64.4699 70.3874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M68.736 44.1225C67.7001 45.3717 67.0602 46.8951 66.9383 48.51C66.9383 48.51 65.3235 60.2711 65.4149 60.7891L67.4258 63.2266L73.0931 59.7531C75.0126 58.5648 76.5665 56.889 77.572 54.8781L101.094 8.13862C101.551 7.22455 100.332 6.43236 99.662 7.19409L68.7665 44.092L68.736 44.1225Z",
    fill: "#D4F0E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M0.911728 59.2058C-0.093748 59.2667 -0.185174 60.7292 0.820302 60.912L48.23 69.23C49.8144 69.5042 51.4597 69.291 52.9223 68.5903C52.9223 68.5903 63.9215 64.1113 64.3176 63.7761L65.4145 60.8205L59.595 57.6518C57.6145 56.5854 55.3902 56.0675 53.1355 56.2199L0.911728 59.2058V59.2058Z",
    fill: "#D4F0E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M54.0073 68.7147C52.1253 69.4981 50.084 69.726 48.0461 69.3568L0.933698 61.0033C0.0193826 60.85 0.0560311 59.454 0.975344 59.4169L42.3127 63.5368C42.3127 63.5368 60.7926 62.4904 61.1309 62.84L61.1309 65.34L54.0073 68.7147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M73.4379 60.117C75.36 58.9368 76.8983 57.2746 77.9097 55.2482L101.129 8.34016C101.594 7.43863 100.765 7.05118 100.13 7.84009L76.5532 46.608C76.5532 46.608 65.7155 60.635 65.8009 61.1486L67.8033 63.5811L73.4379 60.117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M61.2012 64.1961L61.2012 65.1101C61.2012 66.2984 62.9988 71.3867 64.9488 71.3867C66.7465 71.3867 68.6965 66.1461 68.6965 65.1101L68.6965 64.1961C68.6965 62.825 67.0207 61.6976 64.9488 61.6976C62.877 61.6976 61.2012 62.825 61.2012 64.1961Z",
    fill: "#D4F0E6"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeFan);
export default __webpack_public_path__ + "static/media/large_fan.b7855b51fef213039e25f781525c058c.svg";
export { ForwardRef as ReactComponent };